import * as loglevel from "loglevel"

export const log = loglevel
log.setDefaultLevel("ERROR")
